module.exports = __webpack_public_path__ + "static/media/pt.c31a6c49.svg";